import type { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { graphql } from 'gql';
import type { ContractSeasonData } from 'gql/graphql';

import { useMemo } from 'react';

const getContractSeasonsGql = graphql(`
    query getContractSeasons($contractId: Long!) {
        uerContractSeasons(contractId: $contractId) {
            data {
                id
                year
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const useUerContractSeasons = (
    contractId: number | undefined,
    withEffect = true,
): [ContractSeasonData[], RequestStatus, any] => {
    const variables = useMemo(
        () => ({
            contractId,
        }),
        [contractId],
    );

    const [getContractSeasonsData, getContractSeasonsStatus, getContractSeasonsError] = useRequest({
        requestId: 'getContractSeasons',
        query: getContractSeasonsGql,
        withEffect: withEffect && Boolean(contractId),
        variables,
    });

    const seasons = useMemo(
        () => (getContractSeasonsData?.uerContractSeasons?.data as ContractSeasonData[]) || [],
        [getContractSeasonsData],
    );

    return [seasons, getContractSeasonsStatus, getContractSeasonsError];
};
